import script from "./CartModificationsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartModificationsModal.vue?vue&type=script&setup=true&lang=ts"

import "./CartModificationsModal.vue?vue&type=style&index=0&id=0394f9f6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0394f9f6"]])

export default __exports__